// hooks/useSilentAuthGuard.js
import { useEffect } from 'react';
import { useGetSessionQuery } from '../api/apiSlice';
import {
  canRedirect,
  setLockFor,
  isOnSilentLogin,
  LOCK_MS,
} from '@/utils/authRedirectLock';

export function useSilentAuthGuard() {
  const { data, error, isLoading } = useGetSessionQuery();

  useEffect(() => {
    if (isLoading || isOnSilentLogin()) return;

    if (data?.authenticated === false && canRedirect()) {
      const returnTo = window.location.pathname + window.location.search;
      setLockFor(LOCK_MS);
      window.location.href = `/auth/silent-login?returnTo=${encodeURIComponent(returnTo)}`;
    }

    if (error && canRedirect()) {
      console.warn('Auth check failed', error);
    }
  }, [data, isLoading, error]);
}
